import { useEffect, useState, type MouseEvent } from 'react';
import { useRouteMatch } from 'react-router-dom';
import type { NavBarListProps } from '../components';

export const useNavBarList = ({ menu, isOpen, isMobile }: Omit<NavBarListProps, 'onClick'>) => {
  const [openAccordion, setOpenAccordion] = useState(false);

  const routeMatch = useRouteMatch(menu?.to);
  const isActive = routeMatch?.isExact;

  useEffect(() => {
    setOpenAccordion(isOpen);
  }, [isOpen]);

  const onMouseEnter = (event: MouseEvent<HTMLElement> | UIEvent) => {
    if (isMobile) {
      return;
    }

    setOpenAccordion(true);
  };

  const onMouseLeave = () => {
    if (isMobile) {
      return;
    }

    setOpenAccordion(false);
  };

  return {
    isActive,
    onMouseEnter,
    onMouseLeave,
    openAccordion,
  };
};
